import { supabase } from '../supabaseClient';

// Notifications
export const fetchProfileNotifications = async () => {
  const { data, error } = await supabase
    .from('notifications')
    .select(`
      id,
      datetime,
      notificationsprofile!left (
        id,
        read_at,
        user_id
      )
    `)
    .order('datetime', { ascending: false });

  if (error) {
    alert(`Error fetching profile notifications: ${error.message}`);
    throw error;
  }
  return data;
};

export const fetchNotifications = async () => {
  const { data, error } = await supabase
    .from('notifications')
    .select('*')
    .order('id');

  if (error) {
    alert(`Error fetching notifications: ${error.message}`);
    throw error;
  }
  return data;
};

export const addUpdateNotifications = async (notification, notificationId) => {
  const { error } = notificationId
    ? await supabase.from('notifications').update(notification).eq('id', notificationId)
    : await supabase.from('notifications').insert([notification]);

  if (error) {
    alert(`Error saving: ${error.message}`);
    throw error;
  }
  return true;
};


// Email Notifications
export const notifySpotFree = async (emails, className, dateTime) => {
  try {
    console.log('Invoking notify-spot-free with:', { emails, className, dateTime });
    await supabase.functions.invoke('notify-spot-free', {
      body: {
        emails: emails,
        class_name: className,
        dateTime: dateTime,
      },
    });
  } catch (error) {
    alert(`Error sending notifications: ${error.message}`);
    throw error;
  }
};

// Email Notifications
export const notifyReservation = async (email, className, dateTime) => {
  try {
    await supabase.functions.invoke('notify-class-reserved', {
      body: {
        email: email,
        class_name: className,
        dateTime: dateTime,
      },
    });
  } catch (error) {
    alert(`Error sending notifications: ${error.message}`);
    throw error;
  }
};


export const notifyBonusUsers = async (message) => {
  try {
    await supabase.functions.invoke('notify-bonus-users', {
      body: {
        message: message,
      },
    });
  } catch (error) {
    alert(`Error sending notifications: ${error.message}`);
    throw error;
  }
};

export const notifyClassAttendees = async (message, calendarClassId) => {
  try {
    await supabase.functions.invoke('notify-class-attendees', {
      body: {
        calendarclassId: calendarClassId,
        message: message,
      },
    });
  } catch (error) {
    alert(`Error sending notifications: ${error.message}`);
    throw error;
  }
};

export const notifyWaitlistForClass = async (calendarClassId, className, dateTime) => {
  try {
    const { data: waitlisted } = await supabase
      .from('classprofile')
      .select('profiles: profiles(email)')
      .eq('calendar_class', calendarClassId)
      .eq('waiting_list', true)
      .is('canceled_at', null);

    const emails = (waitlisted || []).map((s) => s.profiles?.email).filter(Boolean);
    if (emails.length === 0) return;

    await notifySpotFree(emails, className, dateTime);
  } catch (error) {
    console.error('Error notifying waitlist:', error);
  }
};

export const notifyTrial = async (type, userEmail, className, dateTime) => {
  try {
    await supabase.functions.invoke('notify-trial', {
      body: {
        type,
        user_email: userEmail,
        class_name: className,
        dateTime: dateTime,
      },
    });
  } catch (error) {
    console.error('Error sending trial notification:', error);
  }
};



